import * as Yup from 'yup';
import { useState, useContext, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import FormControlLabel from '@mui/material/FormControlLabel';
import uuid from 'react-uuid';


// material
import { Stack, TextField, Alert, Autocomplete, Checkbox, Typography, Button, Container, Grid, Card, Box, CardActionArea} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ThemeProvider, styled } from '@mui/material/styles';
import Theme from '../../../components/Button';

import ImagemList from '../../Produto/ImagemProduto/ImagemList';

import { api, reiniciarToken, cadastrarProdutos, consultaFornecedores } from '../../../services/api';
// context
import { AuthContext } from '../../../contexts/auth';

import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

export default function CadProdutoForm() {

  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  })
  const [images, setListImages] = useState([]);
  const [showElement, setShowElement] = useState(false);

  const RegisterSchema = Yup.object().shape({
    descricao: Yup.string().min(2, 'Muito Pequeno!').max(500, 'Muito Longo!').required('Descrição é obrigatório'),
    id_fornecedor: Yup.string().required('Fornecedor é obrigatório'),
    preco_custo: Yup.string().required('Preço de Custo é obrigatório'),
    qtde_estoque: Yup.string().required('Qtde de Estoque é obrigatório'),
  });

  const formik = useFormik({
   initialValues: {
        descricao: '',
        id_fornecedor: '',
        preco_custo: '',
        preco_venda_inicial: '',
        qtde_estoque: '',
        movimenta_estoque: false,
        observacao_template: '',
        codigo_barra: '',
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      navigate('/dashboard', { replace: true });
    },
  });

  const handleSubmit = async e => {
    e.preventDefault();

    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const json = {descricao: formik.values.descricao,
                  id_fornecedor: formik.values.id_fornecedor,
                  preco_custo: formik.values.preco_custo,
                  preco_venda_inicial: formik.values.preco_venda_inicial,
                  qtde_estoque: formik.values.qtde_estoque,
                  movimenta_estoque: Number(formik.values.movimenta_estoque),
                  usuario: localStorage.getItem(['usuario']),
                  id_empresa: localStorage.getItem(['id_empresa']),
                  observacao_template: formik.values.observacao_template,
                  codigo_barra: formik.values.codigo_barra,
                  imagens: images};          

    const response = await cadastrarProdutos(json);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
    }; 
  }

  const [fornecedores, setListFornecedor] = useState([]);

  const getListas = async () => {

    const responseFornecedor = await consultaFornecedores();

    if(responseFornecedor.erro === true) {
      if (responseFornecedor.mensagem === 'O Token é inválido!' || responseFornecedor.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      responseFornecedor.data.forEach((valores) => {
        setListFornecedor(fornecedores => [...fornecedores, {id_fornecedor: valores.id_fornecedor, nome_fantasia: valores.nome_fantasia}])
      }); 
    };
  }

  const convertToBase64 = (file) => {
      return new Promise(resolve => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
              resolve(reader.result);
          }
      })
  }

  const onSelectFile = async (event) => {
      
      const file = event.target.files[0];
      const convertedFile = await convertToBase64(file);

      setListImages(images => [...images, {id: uuid(), image: convertedFile, imageName: file.name}])
  }

  useEffect(() => {
    
    const renovarToken = async () => {
      const retorno = await reiniciarToken();
      if(retorno.erro === true) {
        if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
          logout();
        }
      }else{
        localStorage.setItem("token", retorno.data.token);
        api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
      }
    };

    renovarToken();
    getListas();

    if ((localStorage.getItem(['tipo_comercio']) === '6')) {
      setShowElement(true);  
    }

  },[]);

  const removeImagem = async (codigo) => {
    setListImages(current => current.filter(image => image.id !== codigo));
  }

  const { errors, touched, isSubmitting, getFieldProps, handleBlur, handleChange, setFieldValue} = formik;

  const ProductImgStyle = styled('img')({
    top: 0,
    width: '100%',
    height: '100%',
    position: 'absolute',
  });
  
  return (
    <FormikProvider value={formik}>
      <Stack mb={3}>
        <TextField 
          fullWidth
          label="Código Barra"
          onChange={(ev) => { 
            setFieldValue('codigo_barra', ev.target.value, false) 
          }}
        />
      </Stack>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField 
              fullWidth
              label="Descrição"
              {...getFieldProps('descricao')}
              error={Boolean(touched.descricao && errors.descricao)}
              helperText={touched.descricao && errors.descricao}
            />
            <Autocomplete
                getOptionLabel={(resultado) => resultado.nome_fantasia}
                options={fornecedores}
                fullWidth
                onChange={(e, value) => { 
                  setFieldValue('id_fornecedor', value?.id_fornecedor, false) 
                }}
                renderInput={(params) => (<TextField {...params} 
                                            label="Fornecedor" 
                                            fullWidth
                                            {...getFieldProps('id_fornecedor')}
                                            error={Boolean(touched.id_fornecedor && errors.id_fornecedor)}
                                            helperText={touched.id_fornecedor && errors.id_fornecedor}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={formik.values?.id_fornecedor}
                                            />
                                          )}
                isOptionEqualToValue={(option, value) => option.id_fornecedor === value.id_fornecedor}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <NumberFormat
              fullWidth
              label="Preço de Custo"
              {...getFieldProps('preco_custo')}
              error={Boolean(touched.preco_custo && errors.preco_custo)}
              helperText={touched.preco_custo && errors.preco_custo}
              customInput={TextField}
              decimalSeparator={','}
            />
            <NumberFormat
              fullWidth
              label="Preço de Venda Inicial"
              {...getFieldProps('preco_venda_inicial')}
              error={Boolean(touched.preco_venda_inicial && errors.preco_venda_inicial)}
              helperText={touched.preco_venda_inicial && errors.preco_venda_inicial}
              customInput={TextField}
              decimalSeparator={','}
            />
            <TextField
              fullWidth
              label="Qtde Estoque"
              {...getFieldProps('qtde_estoque')}
              error={Boolean(touched.qtde_estoque && errors.qtde_estoque)}
              helperText={touched.qtde_estoque && errors.qtde_estoque}
            />
          </Stack>
          {!showElement && null}
          {showElement &&
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                multiline='true'
                rows={2}
                rowsMax={4}
                label="Template Observação"
                {...getFieldProps('observacao_template')}
              />
            </Stack>
          }
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <FormControlLabel
                control={<Checkbox
                  checked={formik.values.movimenta_estoque}
                  name="movimenta_estoque"
                  onChange={(newValue) =>
                    setFieldValue(
                      'movimenta_estoque',
                       newValue.target.checked,
                    )
                  }
                  />
                }
                label={<Typography>Movimenta Estoque</Typography>}
            />
            <ThemeProvider theme={Theme}>
                <Button variant="contained" color="neutral" component="label" startIcon={<Iconify icon="ion:attach" />}>
                    Adicionar Imagem
                    <input
                        type="file" 
                        hidden
                        accept="image/*"
                        onChange={onSelectFile}
                        name="image"
                    />
                </Button>
            </ThemeProvider>
          </Stack>
          
          <Container>     
            <Grid container spacing={3}>
              {images.sort((a,b) => a.id - b.id).map((product) => (
                <Grid key={product.id} item xs={12} sm={6} md={3}>
                  <CardActionArea>
                    <Card onClick={() => removeImagem(product.id)}>
                      <Box sx={{ pt: '100%', position: 'relative' }}>
                        <ProductImgStyle src={product.image} />
                      </Box>
                      <Stack spacing={2} alignItems="center" sx={{ p: 1 }}>
                        <Typography variant="button">Remover</Typography>
                      </Stack>
                    </Card> 
                  </CardActionArea>
                </Grid> 
              ))}
            </Grid>
          </Container>       
          
          <Stack spacing={3}>
            {status.type === 'erro' ? <Alert severity="error">{status.mensagem}</Alert> : ""}
            {status.type === 'success' ? <Alert severity="success">{status.mensagem}</Alert> : ""}
          </Stack>

          <ThemeProvider theme={Theme}>
            <LoadingButton fullWidth size="large" type="submit" variant="contained" color="neutral" loading={isSubmitting}>
              Cadastrar
            </LoadingButton>
          </ThemeProvider>
        </Stack>  
      </Form>
    </FormikProvider>
  );
}
